const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';

async function strapiFetch(path) {
  const response = await fetch(`${STRAPI_URL}${path}`);

  if (!response.ok) {
    throw new Error(`Strapi request failed: ${response.status} ${response.statusText}`);
  }

  return response.json();
}

export function getCategories() {
  return strapiFetch('/api/categories?sort=name:asc');
}

export function getCategoriesWithEquipment() {
  return strapiFetch('/api/categories?sort=name:asc&populate[equipment]=true');
}

export function getCategoryBySlug(slug) {
  const params = new URLSearchParams({
    'filters[slug][$eq]': slug,
    'populate[equipment]': 'true',
  });

  return strapiFetch(`/api/categories?${params.toString()}`);
}

export { STRAPI_URL };
